import React from "react";
import { Card } from "../modules/UserManagment";

export function UserCardPage(props) {
  return <Card {...props} />;
}
